export const UPDATE_FORM = 'UPDATE_FORM';

export const initialState = {
    amount: 10000,
    compoundingInterval: 12,
    period: 10,
    rate: 8,
    principalAmount: 1200000,
    maturityAmount: 1829460,
    oneTime: false,
    initialInvestment: 0,
    regularDepositInterval: 12,
    data: [],
};

export const updateForm = (fieldValue, val) => ({
    type: UPDATE_FORM,
    field: fieldValue,
    value: val,
});

export const formReducer = (state = initialState, action) => {
    if (action.type === UPDATE_FORM) {
        return {
            ...state,
            [action.field]: action.value,
        };
    }
};